import ResultsTable from './ResultsTable'
export default ResultsTable
